const initialState = {
  loading: false,
  user: null,
  error: null,
};

export const AssociationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ASS_REQUEST":
      return { ...state, loading: true };
    case "GET_ASS_SUCCESS":
      return { ...state, loading: false, success: true, user: action.payload };
    case "GET_ASS_FAIL":
      return { ...state, loading: false, error: action.payload };
    case "GET_ASS_RESET":
      return initialState;
    default:
      return state;
  }
};

export const updateStudentReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case "REQUEST_EDIT_STUDENT":
      return { ...state, loading: true };
    case "SUCCESS_EDIT_STUDENT":
      return { ...state, loading: false, success: true, data: action.payload };
    case "FAIL_EDIT_STUDENT":
      return { ...state, loading: false, error: action.payload };
    case "RESET_EDIT_STUDENT":
      return { loading: false };
    default:
      return state;
  }
};

export const addStudentReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case "REQUEST_ADD_STUDENT":
      return { ...state, loading: true };
    case "SUCCESS_ADD_STUDENT":
      return { ...state, loading: false, success: true, data: action.payload };
    case "FAIL_ADD_STUDENT":
      return { ...state, loading: false, error: action.payload };
    case "RESET_ADD_STUDENT":
      return { loading: false };
    default:
      return state;
  }
};
